// extracted by mini-css-extract-plugin
export default {"licName":"Lics_licName__6nBO7","key":"Lics_key__Ii6ku","duration":"Lics_duration__YeD4P","subject":"Lics_subject__TKn2q"};